// extracted by mini-css-extract-plugin
export default {"textLink":"MMwA7DffIZiIRFRX7DQP__textLink___"};